import React, { useEffect, useState } from "react";
import { translate } from "../Services/translation";
import { subcribeToBackInStock } from "../Services/Product.service";

export default ({ className, articleNumber, visible, privacyPolicyUrl, showError = true, onError }) => {
    const [email, setEmail] = useState();
    const [error, setError] = useState();
    const [subscribed, setSubscribed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setError();
        setIsLoading();
        setSubscribed();
    }, [articleNumber])
    
    useEffect(() => {
        if(onError) onError(error);
    }, [error])

    const onKeyDownInput = e => {
        if(e.key == "Enter") {
            onSubmit(articleNumber, email);
        }
    }

    const onSubmit = async (articleNumber, email) => {
        setIsLoading(true);
        try {
            await subcribeToBackInStock(articleNumber, email);
            setSubscribed(true);
            setError(null);
        }catch(err) {
            let res;
            
            if(err.response) {
                try {
                    res = await err.response.json();
                }catch(_) {}
            }

            let errorMessage = null;
            if(res) {
                errorMessage = res.message;
            }
            setSubscribed(false);
            if(err.response.status == 409) {
                // Conflict, already subscribed
                setError(errorMessage || translate("size-picker.notify-me.conflict"));
            }else{
                // Something went wrong, display error response or generic error message
                setError(errorMessage || translate("size-picker.notify-me.error"));
            }
        }
        setIsLoading(false);
    }

    return visible && <>
        <div className={className || "notify-me"}>
            <input autoFocus type="email" name="email" onKeyDown={onKeyDownInput} disabled={subscribed} onChange={e => setEmail(e.target.value)} />
            <span className="email-label">{translate("size-picker.email-placeholder")}</span>
            <span className={`send-button ${isLoading || subscribed ? 'send-button--disabled' : ''}`} onClick={() => !isLoading && !subscribed && onSubmit(articleNumber, email)}>
                {!isLoading && !subscribed && translate("size-picker.send")}
                {isLoading && <i className="ph-arrow-clockwise spin"></i>}
                {!isLoading && subscribed && <i className="ph-check"></i>}
            </span>
            {showError && error && 
                <div className="field-wrapper">
                    <div className="input-error">{error}</div>
                </div>
            }
        </div>
        {privacyPolicyUrl && <div className="size-picker__privacy-policy--wrapper"> <a href={privacyPolicyUrl} className="size-picker__privacy-policy">{translate("size-picker.privacy-policy")}</a></div>}
    </>
}